<template>
  <!-- DESKTOP (simple layout): two interactive tabs + the static links -->
  <div
    v-if="layout === 'simple'"
    class="hidden md:flex flex-row items-stretch w-full md:border-0 border-b border-theme-gray-7 divide-x divide-theme-gray-7 overflow-hidden rounded-t-xl"
  >
    <div
      @click="handleClick('distance')"
      :class="drive === 'distance' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
      class="text-size-1 text-center py-4 px-4 uppercase cursor-pointer whitespace-nowrap flex-auto"
    >
      Airport Transfer
    </div>

    <div
      @click="handleClick('hourly')"
      :class="drive === 'hourly' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
      class="text-size-1 text-center py-4 px-4 uppercase cursor-pointer whitespace-nowrap flex-auto"
    >
      Full Day Chauffeur
    </div>

    <div
      @click="router.push({name: 'CarRental'})"
      :class="router.currentRoute.value.name === 'CarRental' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
      class="text-size-1 text-center py-4 px-4 uppercase cursor-pointer whitespace-nowrap flex-auto"
    >
      Car Rental
    </div>

    <div
      @click="router.push({name: 'MeetGreet'})"
      :class="router.currentRoute.value.name === 'MeetGreet' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
      class="text-size-1 text-center py-4 px-4 uppercase cursor-pointer whitespace-nowrap flex-auto"
    >
      Meet &amp; Greet
    </div>

    <div
      @click="router.push({name: 'BusesCoaches'})"
      :class="router.currentRoute.value.name === 'BusesCoaches' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
      class="text-size-1 text-center py-4 px-4 uppercase cursor-pointer whitespace-nowrap flex-auto"
    >
      Buses &amp; Coaches
    </div>

    <div
      @click="router.push({name: 'Planmytrip'})"
      :class="router.currentRoute.value.name === 'Planmytrip' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
      class="text-size-1 text-center py-4 px-4 uppercase cursor-pointer whitespace-nowrap flex-auto"
    >
      Multiple Requests
    </div>
  </div>

  <!-- DESKTOP (full layout): only the two interactive tabs -->
  <div v-else-if="layout === 'full'" class="hidden md:grid grid-cols-3 border-b-2 border-theme-active">
    <div
      @click="handleClick('distance')"
      :class="drive === 'distance' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2 border border-theme-gray-7'"
      class="col-span-3 md:col-span-1 text-size-1 text-center p-5 uppercase cursor-pointer"
    >
      Airport Transfer
    </div>
    <div
      @click="handleClick('hourly')"
      :class="drive === 'hourly' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2 border border-theme-gray-7'"
      class="col-span-3 md:col-span-1 text-size-1 text-center p-5 uppercase cursor-pointer"
    >
      Full Day Chauffeur
    </div>
  </div>

  <!-- MOBILE header: just the toggler and (optionally) the "More" button -->
  <div class="flex md:hidden items-center justify-between bg-theme-active text-white pr-5">
    <div class="flex flex-col divide-y divide-theme-gray-7 border-b border-theme-gray-7">
      <div @click="handleClick(drive)" class="text-size-1 text-center p-5 uppercase cursor-pointer">
        {{ drive === 'hourly' ? 'Full Day Chauffeur' : 'Airport Transfer' }}
      </div>
    </div>

    <!-- Show/Hide the “More” menu via prop -->
    <template v-if="showMoreResolved">
      <button @click="showMoreMenu = true" class="nav-more-btn text-white uppercase text-xs">More</button>
      <Modal :show="showMoreMenu" @closed="showMoreMenu = false">
        <template #content>
          <div class="flex flex-col bg-white z-50 w-full">
            <div
              @click="handleClick('distance')"
              :class="drive === 'distance' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
              class="text-size-1 text-center p-5 uppercase cursor-pointer"
            >
              Airport Transfer
            </div>
            <div
              @click="handleClick('hourly')"
              :class="drive === 'hourly' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
              class="text-size-1 text-center p-5 uppercase cursor-pointer"
            >
              Full Day Chauffeur
            </div>
            <div
              @click="router.push({name: 'CarRental'})"
              :class="router.currentRoute.value.name === 'CarRental' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
              class="text-size-1 text-center p-5 uppercase cursor-pointer"
            >
              Car Rental
            </div>
            <div
              @click="router.push({name: 'MeetGreet'})"
              :class="router.currentRoute.value.name === 'MeetGreet' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
              class="text-size-1 text-center p-5 uppercase cursor-pointer"
            >
              Meet &amp; Greet
            </div>
            <div
              @click="router.push({name: 'BusesCoaches'})"
              :class="router.currentRoute.value.name === 'BusesCoaches' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
              class="text-size-1 text-center p-5 uppercase cursor-pointer"
            >
              Buses &amp; Coaches
            </div>
            <div
              @click="router.push({name: 'Planmytrip'})"
              :class="router.currentRoute.value.name === 'Planmytrip' ? 'bg-theme-active text-white' : 'bg-white hover:text-theme-active text-theme-gray-2'"
              class="text-size-1 text-center p-5 uppercase cursor-pointer"
            >
              Multiple Requests
            </div>
          </div>
        </template>
      </Modal>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import type { DriveType } from '@/types'
import Modal from '@/widgets/Modal.vue'

const props = defineProps<{
  layout?: string
  driveType?: string
  /** If false, hides the “More” button+modal on mobile */
  showMore?: boolean
}>()

const emit = defineEmits(['driveType'])
const router = useRouter()

const drive = ref<DriveType>((props.driveType as DriveType) || 'hourly')
const showMoreMenu = ref(false)
const showMoreResolved = computed(() => props.showMore !== false)

/* Keep internal state in sync with parent */
watch(() => props.driveType, (val) => {
  if (val && val !== drive.value) drive.value = val as DriveType
})

const handleClick = (type: string) => {
  // Toggle if user taps current label on mobile
  if (type !== 'distance' && type !== 'hourly') {
    type = drive.value === 'hourly' ? 'distance' : 'hourly'
  }
  drive.value = type as DriveType
  emit('driveType', type)
  showMoreMenu.value = false
}
</script>
